import Index from 'src/pages/Stats/Index.vue'
import Unused from 'src/pages/Stats/Unused.vue'
import Rotations from 'src/pages/Stats/Rotations.vue'
import Revenue from 'src/pages/Stats/Revenue.vue'
import Warehouses from 'src/pages/Stats/Warehouses.vue'

const auth = { requiresAuth: true }
const admin = { requiresAdmin: false }

export default [
  {
    path: '/stats',
    name: 'Statistik',
    component: Index,
    meta: { ...auth, ...admin },
    redirect: '/stats/revenue',
    children: [
      {
        path: 'unused',
        component: Unused,
        name: 'Lagerhüter'
      },
      {
        path: 'rotations',
        component: Rotations,
        name: 'Einbuchungen / Ausbuchungen'
      },
      {
        path: 'revenue',
        component: Revenue,
        name: 'Umsatz'
      },
      {
        path: 'warehouses',
        component: Warehouses,
        name: 'Lagerwert'
      }
    ]
  }
]
